import { render, staticRenderFns } from "./SVGPhotoDelete.vue?vue&type=template&id=285e5ad4&scoped=true&"
import script from "./SVGPhotoDelete.vue?vue&type=script&lang=js&"
export * from "./SVGPhotoDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e5ad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285e5ad4')) {
      api.createRecord('285e5ad4', component.options)
    } else {
      api.reload('285e5ad4', component.options)
    }
    module.hot.accept("./SVGPhotoDelete.vue?vue&type=template&id=285e5ad4&scoped=true&", function () {
      api.rerender('285e5ad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/SVG/SVGPhotoDelete.vue"
export default component.exports